import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20waves%20with%20calm%20blue%20and%20teal%20gradients%2C%20smooth%20flowing%20organic%20shapes%2C%20minimalist%20digital%20art%20background%2C%20gentle%20light%20accents%2C%20clean%20modern%20aesthetic%2C%20sophisticated%20tech%20texture%2C%20no%20text%20no%20people%2C%20elegant%20ambient%20composition&width=1920&height=900&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好让你的导航栏焕然一新了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg mx-auto leading-relaxed">
          五分钟快速集成，零依赖极致轻量。数千名开发者已经选择了蓝色小导航，加入他们吧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/quick-start"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-950 font-semibold text-sm hover:bg-accent-400 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-lg"></i>
            开始使用
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-mail-line text-lg"></i>
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}